import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4531f849"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "GroundWork" }
const _hoisted_2 = { id: "section1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ProgressFld\" data-v-4531f849><div class=\"progBar\" data-v-4531f849><p class=\"bar\" data-v-4531f849></p></div></div><div class=\"QuestionFld\" data-v-4531f849><div class=\"QuestionText\" data-v-4531f849>あなたの<br data-v-4531f849>性別を教えてください</div></div>", 2)
const _hoisted_5 = { class: "AnserFld" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.MenColor === 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "AnserMen",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.MenColorChange && _ctx.MenColorChange(...args)))
            }, "男性"))
          : _createCommentVNode("", true),
        (_ctx.MenColor === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "AnserMenYellow",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.MenColorChange && _ctx.MenColorChange(...args)))
            }, "男性"))
          : _createCommentVNode("", true),
        (_ctx.WomenColor === 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "AnserWoMen",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.WoMenColorChange && _ctx.WoMenColorChange(...args)))
            }, "女性"))
          : _createCommentVNode("", true),
        (_ctx.WomenColor === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "AnserWoMenYellow",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.WoMenColorChange && _ctx.WoMenColorChange(...args)))
            }, "女性"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}